<template>
  <t-dropdown toggle-on-hover variant="rich-input-emoji">
    <template #trigger>
      <base-button variant="rich-input" class="flex items-center">
        <emoji-icon class="h-5 w-5"/>
      </base-button>
    </template>

    <template>
      <v-emoji-picker ref="emojiPicker" class="emoji-picker-wrapper" @select="pickEmoji"/>
    </template>
  </t-dropdown>
</template>

<script>
// https://www.npmjs.com/package/v-emoji-picker
import { VEmojiPicker } from 'vue-emoji-picker-custom'
import BaseButton from '@/components/base-components/BaseButton.vue'
import EmojiIcon from '@/assets/images/icons/EmojiIcon.vue'

export default {
  name: 'RichInputEmojis',

  components: {
    EmojiIcon,
    BaseButton,
    VEmojiPicker
  },

  methods: {
    pickEmoji(emoji) {
      this.$emit('insert-emoji', emoji)
    }
  }
}
</script>

<style lang="scss">
.emoji-picker-wrapper {
  background-color: #ffffff !important;
  width: 250px !important;
  border: 1px solid #B6C4D8 !important;

  input {
    background-color: #ffffff !important;
  }

  #Categories {
    background-color: #ffffff !important;

    .category {
      padding: 4px 0 !important;
    }

    .category.active {
      border-bottom: 3px solid #7e50FF !important;
    }
  }

  .container-emoji {
    height: 155px !important;
  }

  .grid-emojis {
    grid-template-columns: repeat(6, 16.66%) !important;

    .emoji {
      font-size: 18px !important;
      line-height: 18px !important;
      height: 18px !important;
      width: 18px !important;
    }
  }
}
</style>
